import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DueDiligenceService } from '../../services/due-diligence/due-diligence.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UploadService } from '../../services/upload/upload.service';
import { documentInformation } from '../../model/document.model';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { SearchTermservice } from '../../services/search/search-service.service';
import { AgentDashboardService } from '../../services/agent_dashboard/agent-dashboard.service';
import * as momenttimezone from 'moment-timezone';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import {GetDocStatusByRole} from '../../../shared/globalService';
@Component({
  selector: 'app-due-diligence-dialog',
  templateUrl: './due-diligence-dialog.component.html',
  styleUrls: ['./due-diligence-dialog.component.css']
})

export class DueDiligenceDialogComponent implements OnInit {
  public sssPattern: any = '[A-Za-z0-9_]';
  public selectedDocName: any;
  public businessForm: boolean = false;
  public w9Form: boolean = false;
  public agreementForm: boolean = false;
  public submitFormData: any;
  public agentId: any;
  externalURL: any;
  documentInfo: documentInformation = new documentInformation();
  message: any;
  ssnNumber: any;
  states: any = [];
  listOfStates: any = [];
  chooseFile: boolean = false;
  updateFile: boolean = false;
  matSpinner: boolean = false;
  onChangeFileName: string;
  onChangeFile: boolean = false;
  isFileChanged: boolean = false;
  errorMsg: boolean = false;
  loginId;
  logFormData: any;
  errMsg;
  errFlag: boolean = false;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  SSNNumber = "";
  vendorName;
  uploadFlag: boolean = true;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  Role: string;
  DocumentStatus: string;
  minDate = new Date();
  data: any = {
    LicenseNumber: '',
    IssueDate: '',
    OwnerName: '',
    DateSigned: '',
    agentName: '',
    EINOrSSN: '',
    ExpirationDate: '',
    IssueState: '',
    uploadedFile: '',
    FileName1: '',
  }
  previousValues: any = [];
  dateRequired: boolean = true;

  constructor(
    private getDocStatusByRole: GetDocStatusByRole,
    private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService,
    private agentDashboardService: AgentDashboardService,
    private uploadService: UploadService,
    private searchTermservice: SearchTermservice,
    private dueDiligenceService: DueDiligenceService,
    public dialogRef: MatDialogRef<DueDiligenceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public agentData: any, public ref: ChangeDetectorRef) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.vendorName = localStorage.getItem('AgentName');
    this.agentId = localStorage.getItem("AgentId");
    this.Role = localStorage.getItem('Role');
    if (this.agentData.data.DocumentTypeName == "Good Standing Certificate") {
      this.businessForm = true;
    } else if (this.agentData.data.DocumentTypeName == "W-9 form") {
      this.w9Form = true;
    } else if (this.agentData.data.DocumentTypeName == "Agreement/Contract") {
      this.agreementForm = true;
    } else if (this.agentData.data.DocumentTypeName == "Additional Documents"){
      this.dateRequired = false;
    }

    if (this.agentData.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      this.data = this.agentData.data;
      this.data.FileName1 = this.agentData.data.FileName;
      if (this.data.ExpirationDate != null) {
        let dt =this.data.ExpirationDate? new Date(this.data.ExpirationDate): "";
        if (dt !== undefined)
          this.data.ExpirationDate = dt;
      }
    }

    if (this.agentData.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }
    this.data.agentName = this.agentData.agent_name;
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Upload a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.FileName1 = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  saveDocument() {
    this.matSpinner = true;
    let today = new Date();
    this.uploadFlag = false;
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');

    if (this.isFileChanged === false && this.agentData.type === 'update') {
      this.externalURL = this.data.DocumentLink;
      this.submitForm();
    } else {
      let filePath = "Agent/" + this.agentId + "/duediligence/" + this.agentData.data.DocumentTypeCode + "/";
      this.data.FileName1 = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": this.newFilePath1,
        "vendor_id": this.agentId
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
          this.externalURL = this.newFilePath1;
          this.submitForm();
        });
      }, (err) => {
        this.matSpinner = false;
        
      });
    }
  }

  onFileChange(event) {
    this.isFileChanged = true;
    this.onChangeFile = false;
    const reader = new FileReader();
    const formInput: FormData = new FormData();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.onChangeFileName = file.name;
      var extName = file.name.split('.').pop();
      var ext = extName.toLowerCase()
      if (ext == "docx" || ext == "pdf" || ext == "doc" || ext == "png" || ext == "jpg" || ext == "xls" || ext == "xlsx") {
        formInput.append('file', file, file.name);
        this.documentInfo.fileInput = formInput;
        this.documentInfo.fileName = file.name;
        this.errorMsg = false;
      } else {
        this.errorMsg = true;
      }
    }
  }

  submitForm() {
    if(this.data.ExpirationDate){
    const setTime = new Date(this.data.ExpirationDate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
  }
    this.logFormData = {
      "document_type": this.agentData.data.DocumentTypeName,
      "document_category": this.agentData.data.DocumentCategory,
      "transaction_type": "Add",
      "vendor_id": this.agentId
    }
    if (this.agentData.type === 'create') {

      this.submitFormData = {
        "MasterVendorId": this.agentId,
        "DocumentTypeCode": this.agentData.data.DocumentTypeCode,
        "OwnerName": this.data.OwnerName,
        "DateSigned": this.data.DateSigned,
        "LicenseNumber": this.data.LicenseNumber,
        "IssueDate": this.data.IssueDate,
        "ExpirationDate": testTimeZone,
        "EINOrSSN": this.data.EINOrSSN || null,
        "FileName": this.data.FileName1,
        "DocumentLink": this.externalURL,
        "IssueState": this.data.IssueState,
        "DocumentStatus":  this.getDocStatusByRole.docStatusByRole()
      }
      this.submitFormData.CreatedBy = this.loginId;
      this.submitFormData.LastUpdatedBy = this.loginId;
      this.logFormData.modified_by = this.loginId;
      this.dueDiligenceService.submitDocumentVal(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.dueDiligenceService.load.next('success');
        this.agentDashboardService.load.next('success');
        this.onNoClick();
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
          this.errMsg = err;
          this.errFlag = true;
          this.matSpinner = false;
        });
      }, error => {
        this.DocTypeErrMsg = 'Due Diligence Service' + ' ' + error;
        this.DocTypeErr = true;
        this.matSpinner = false;
      });
    } else if (this.agentData.type === 'update') {
      this.submitFormData = {
        "MasterVendorId": this.agentId,
        "DocumentTypeCode": this.agentData.data.DocumentTypeCode,
        "OwnerName": this.data.OwnerName,
        "DateSigned": this.data.DateSigned,
        "LicenseNumber": this.data.LicenseNumber,
        "IssueDate": this.data.IssueDate,
        "ExpirationDate": testTimeZone,
        "EINOrSSN": this.data.EINOrSSN || null,
        "FileName": this.data.FileName1,
        "DocumentLink": this.externalURL,
        "IssueState": this.data.IssueState,
        "DocumentStatus":  this.getDocStatusByRole.docStatusByRole(),
        "FileUpdated": this.isFileChanged
      }
      this.submitFormData.LastUpdatedBy = this.loginId;
      this.logFormData.modified_by = this.loginId;
      this.dueDiligenceService.updateDueDocuments(this.agentData.data._id, this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.dueDiligenceService.load.next('success');
        this.agentDashboardService.load.next('success');
        this.onNoClick();
        if (this.logFormData.transaction_type == "Add") {
          this.logFormData.transaction_type = "Edit";
          this.previousValues = localStorage.getItem('old');
          this.logFormData.previous_fields = JSON.parse(this.previousValues);
          this.logFormData.collection_name = "vendor_due_diligence_documents";
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errMsg = err;
            this.errFlag = true;
            this.matSpinner = false;
          });
        }
      }, error => {
        this.DocTypeErrMsg = 'Due Diligence Service' + ' ' + error;
        this.DocTypeErr = true;
        this.matSpinner = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/due-diligence-dialog/due-diligence-dialog.component.ts